import { Facebook, Instagram, Share2 } from "lucide-react";
import { Reveal } from "./Reveal";
import { toast } from "sonner";

export const APINITY_FACEBOOK = "https://www.facebook.com/share/1Df9xddvVC/?mibextid=wwXIfr";
export const APINITY_INSTAGRAM = "https://www.instagram.com/apinity_happyaffinity?stkn=cGI1cTg1d3J6N2hr&utm_source=qr";

// Bandeau « suivre + partager » — dark=true sur les pages sombres (Speed Dating)
export const SocialBand = ({ dark = false, shareText = "Un·e ami·e célibataire ? Partagez-lui APINITY — le test de compatibilité en 10 questions" }) => {
  const share = async () => {
    const payload = { title: "APINITY — Happy Affinity", text: shareText, url: window.location.origin };
    if (navigator.share) {
      try {
        await navigator.share(payload);
        return;
      } catch {}
    }
    try {
      await navigator.clipboard.writeText(`${shareText} — ${window.location.origin}`);
      toast.success("Lien copié — partagez-le à vos amis !");
    } catch {
      toast.error("La copie n'a pas abouti.");
    }
  };

  return (
    <Reveal>
      <div
        className={`rounded-3xl border p-8 text-center shadow-card sm:p-10 ${
          dark ? "border-gold/30 bg-[#5E1424]" : "border-gold/40 bg-white/85"
        }`}
        data-testid="social-band"
      >
        <img
          src="/assets/gift-cards-email.jpeg"
          alt="Les quatre cartes APINITY"
          className="mx-auto w-full max-w-md rounded-2xl border border-gold/40 shadow-boho"
          data-testid="social-band-cards"
        />
        <h2 className={`mt-6 font-serif text-2xl font-medium ${dark ? "text-cream" : "text-ink"}`}>Suivez APINITY</h2>
        <p className={`mx-auto mt-2 max-w-md text-sm leading-relaxed ${dark ? "text-cream/70" : "text-clay"}`}>
          Les coulisses, les soirées en avant-première et les belles histoires — tout passe par là.
        </p>
        <div className="mt-6 flex flex-wrap items-center justify-center gap-3">
          <a
            href={APINITY_FACEBOOK}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="social-facebook"
            className={`flex items-center gap-2 rounded-full px-6 py-3 text-sm font-semibold shadow-boho transition-all duration-300 hover:scale-[1.03] ${
              dark ? "bg-gold text-[#4A0D1A] hover:bg-gold-light" : "bg-terra text-cream hover:bg-terra-dark"
            }`}
          >
            <Facebook size={16} /> Suivre sur Facebook
          </a>
          <a
            href={APINITY_INSTAGRAM}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="social-instagram"
            className={`flex items-center gap-2 rounded-full border px-6 py-3 text-sm font-semibold transition-all duration-300 hover:scale-[1.03] ${
              dark ? "border-gold/50 text-gold hover:bg-gold/10" : "border-terra/30 bg-white text-terra hover:bg-parch"
            }`}
          >
            <Instagram size={16} /> Suivre sur Instagram
          </a>
          <button
            onClick={share}
            data-testid="social-share"
            className={`flex items-center gap-2 rounded-full border px-6 py-3 text-sm font-semibold transition-all duration-300 hover:scale-[1.03] ${
              dark ? "border-gold/60 bg-gold-light text-[#4A0D1A]" : "border-gold/60 bg-gold-light text-ink"
            }`}
          >
            <Share2 size={16} /> Partager à un·e ami·e célibataire
          </button>
        </div>
      </div>
    </Reveal>
  );
};
